import { Box, Grid, Typography } from '@mui/material';
interface FormHeaderGreetingProps {
  name: string;
  applicationNumber?: string;
  applicationStatus?: string;
  applicationType?: string;
}

function FormHeaderGreeting({
  applicationNumber = '',
  applicationStatus = '',
  applicationType = ''
}: FormHeaderGreetingProps) {
  return (
    <Grid
      container
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}
    >
      {applicationNumber ? (
        <Box sx={{ flexGrow: 1 }}>
          <Typography
            pb={{ xs: '0', md: 2 }}
            fontSize={16}
            color="#6E759F"
            className="greeting_welcome_text"
          >          
            <>
              <br className="text_br" />
              <Typography variant='h5' color='primary'>
                {` Application #: ${applicationNumber}`}
              </Typography>
            </>
          </Typography>
        </Box>
      ) : null}
      {applicationType === 'edit' && (
        <Grid
          item
          xs={12}
          md={applicationNumber ? 6 : 12}
          p={{ xs: '0 !important', md: 2 }}
        >
          <Typography
            pb={2}
            fontSize={16}
            color="#6E759F"
            sx={{ textAlign: { xs: 'left', md: 'right' } }}
            className="weight-600"
          >
            Status:
            <b>
              {' '}
              <span
                style={{
                  color:
                    applicationStatus === 'Approved'
                      ? 'green'
                      : applicationStatus === 'Withdrawn' ||
                        applicationStatus === 'Rejected'
                      ? '#8B0000'
                      : applicationStatus === 'Draft'
                      ? 'gray'
                      : applicationStatus === 'Issued'
                      ? '#b63dff'
                      : applicationStatus === 'In Review' ||
                        applicationStatus === 'Await CO' ||
                        applicationStatus === 'In Review L1' ||
                        applicationStatus === 'In Review L2'
                      ? 'orange'
                      : 'black',
                  fontWeight: 600
                }}
              >
                {applicationStatus}
              </span>
            </b>
          </Typography>
        </Grid>
      )}
    </Grid>   
  );
}

export default FormHeaderGreeting;
